/* eslint-disable react/no-direct-mutation-state */
/* eslint-disable no-unused-vars */
import { Card, LinearProgress } from "@material-ui/core";
import axios from "axios";
import React, { Component } from "react";
import { Button, Form, Modal, Table } from "react-bootstrap";
import swal from "sweetalert";
import { NoticePengelolaanPT } from "../../../../_metronic/_partials/controls";
import AppConfig from "../../../config/AppConfig";
import {
  MDBPagination,
  MDBPageItem,
  MDBPageNav,
  MDBCol,
  MDBRow,
} from "mdbreact";
import session from "redux-persist/lib/storage/session";

class ManajemenRole extends Component {
  constructor(props, context) {
    super(props, context);
    this.modalAdd = this.modalAdd.bind(this);
    this.modalEdit = this.modalEdit.bind(this);
    this.handleClose = this.handleClose.bind(this);
  }
  state = {
    // MODAL ============================
    showAddPengelolaPT: false,
    showDetailsRole: false,
    showDialogDelete: false,
    // ==================================
    loadingBtn: false,
    loadingList: true,
    loadingSearch: false,
    // ==================================
    getRole: [],
    // PAGINATION & SEARCH
    keyword: "",
    totalData: 0,
    totalPaginationNumber: 0,
    limit: 10,
    start: 0,
    currentPage: 1,
    pageLimit: 5,
    showFrom: 0,
    // FORM
    id_pengelola: "",
    nm_pengelola: "",
    hp:"",
    email:"",
    jabatan:"",
  };

  handleClose() {
    this.setState({
      showAddPengelolaPT: false,
      showDetailsRole: false,
      showDialogDelete: false,
      loadingBtn: false,
      id_pengelola: "",
      nm_pengelola: "",
      hp:"",
      email:"",
      jabatan:"",
    });
  }
  isFormValid = () => {
    const { nm_pengelola, hp, email, jabatan } = this.state;
    return (
      nm_pengelola.trim() !== '' &&
      hp.trim() !== '' &&
      email.trim() !== '' &&
      jabatan.trim() !== '' &&
      // Optional: Validate email format
      /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
    );
  }
  onInputForm = (e, type) => {
    this.setState({
      [type]: e.target.value,
    });
  };

  // List ============================================================================
  componentDidMount() {
    this.setState({ loadingList: true });
  
    // Ambil data dari localStorage
    const userdata = localStorage.getItem('sessiondata');
  
    // Jika userdata ada, parsing JSON
    let parsedUserdata = {};
    if (userdata) {
      try {
        parsedUserdata = JSON.parse(userdata);
      } catch (error) {
        console.error("Error parsing userdata:", error);
      }
    }
  
    // Inisialisasi FormData
    const formData = new FormData();
    formData.append("data[keyword]", this.state.keyword);
    
    // Kondisi untuk menambahkan id_sp
    if (parsedUserdata.i_idrole === 3) {
      formData.append("data[id_sp]", parsedUserdata.i_idunit || '');
    }
  
    // Log untuk debug
    console.log("Parsed userdata:", parsedUserdata);
  
    // Kirim request dengan Axios
    axios
      .post(
        AppConfig.ListPengelolaPT +
          "?limit=" +
          this.state.limit +
          "&start=" +
          this.state.start,
        formData
      )
      .then((res) => {
        this.setState(
          {
            loadingList: false,
            loadingSearch: false,
            getRole: res.data.result.data.Result,
            totalData: res.data.result.total_rows,
            totalPaginationNumber: Math.ceil(
              res.data.result.total_rows / this.state.limit
            ),
            showFrom: (this.state.currentPage - 1) * this.state.limit + 1,
          }
        );
      })
      .catch((err) => {
        console.error("Error fetching data:", err);
        this.setState({ loadingList: false });
      });
  }
  

  // Add ============================================================================
  modalAdd() {
    this.setState({
      showAddPengelolaPT: true,
    });
  }

  handleSave = (e) => {
    e.preventDefault();
    this.setState({ loadingBtn: true }); 
    var formData = new FormData();
    let userdata = JSON.parse(localStorage.getItem("userdata"));
    let sessiondata = JSON.parse(localStorage.getItem("sessiondata"));
    let session = "";
    
    if (this.isFormValid()) {
      if (userdata) {
        session = "?id_pengguna=" + userdata.id_pengguna + "&id_unit=" + sessiondata.i_idunit + "&id_role=" + sessiondata.i_idrole;
      }
      formData.append("data[id_sp]", sessiondata.i_idunit);
      formData.append("data[nm_pengelola]", this.state.nm_pengelola);
      formData.append("data[hp]", this.state.hp);
      formData.append("data[email]", this.state.email);
      formData.append("data[jabatan]", this.state.jabatan);
      
      axios
        .post(AppConfig.SavePengelolaPT, formData)
        .then((res) => {
          swal({
            title: "Sukses!",
            text: "Data berhasil disimpan!",
            icon: "success",
            button: "OK!",
          });
          this.componentDidMount();
          this.handleClose();
        })
        .catch((err) => {
          swal({
            title: "Gagal!",
            text: "Gagal menyimpan data!",
            icon: "error",
            button: "OK!",
          });
          console.log(err);
        })
        .finally(() => {
          this.setState({ loadingBtn: false }); 
        });
    } else {
      swal({
        title: "Form Kosong!",
        text: "Harap untuk mengisi field yang tersedia!",
        icon: "error",
        button: "OK!",
      });
      this.setState({ loadingBtn: false });  
    }
  };
  

  // Edit ============================================================================
  modalEdit(val) {
    this.setState({
      showDetailsRole: true,
      id_pengelola: val.id_pengelola,
      nm_pengelola: val.nm_pengelola,
      jabatan: val.jabatan,
      hp: val.hp,
      email: val.email,
    });
  }

  handleEdit = (e) => {
    e.preventDefault();
    var formData = new FormData();
    let userdata = JSON.parse(localStorage.getItem("userdata"));
    let sessiondata = JSON.parse(localStorage.getItem("sessiondata"));
    let session = "";
    this.setState({ loadingBtn: true });
    if (this.isFormValid()) {
      if (userdata) {
      session =
        // "?token="+userdata.token+`
        "?id_pengguna=" +
        userdata.id_pengguna +
        "&id_unit=" +
        sessiondata.i_idunit +
        "&id_role=" +
        sessiondata.i_idrole;
    }
    formData.append("data[id_pengelola]", this.state.id_pengelola);
    formData.append("data[id_sp]", sessiondata.i_idunit);
    formData.append("data[nm_pengelola]", this.state.nm_pengelola);
    formData.append("data[hp]", this.state.hp);
    formData.append("data[email]", this.state.email);
    formData.append("data[jabatan]", this.state.jabatan);
    axios
    .put(AppConfig.UpdatePengelolaPT, formData)
    .then((res) => {
      this.setState({
        loadingBtn: false,
      });
      swal({
        title: "Sukses!",
        text: "Data berhasil diubah!",
        icon: "success",
        button: "OK!",
      });
      this.componentDidMount();
      this.handleClose();
    })
    .catch((err) => {
      swal({
        title: "Gagal!",
        text: "Gagal mengubah data!",
        icon: "error",
        button: "OK!",
      });
      console.log(err);
    });
    }else{
      swal({
        title: "Form Kosong!",
        text: "Harap untuk mengisi field yang tesedia!",
        icon: "error",
        button: "OK!",
      });
      this.setState({ loadingBtn: false });
      
    }
  };

  // Delete ============================================================================
  showDialogDelete(id) {
    var formData = new FormData();
    let userdata = JSON.parse(localStorage.getItem("userdata"));
    let sessiondata = JSON.parse(localStorage.getItem("sessiondata"));
    let session = "";
    if (userdata) {
      session =
        // "?token="+userdata.token+
        "?id_pengguna=" +
        userdata.id_pengguna +
        "&id_unit=" +
        sessiondata.i_idunit +
        "&id_role=" +
        sessiondata.i_idrole;
    }
    swal({
      title: "Apakah anda yakin?",
      text: "Data akan terhapus dan tidak tercatat pada historical",
      icon: "warning",
      buttons: true,
      dangerMode: false,
    }).then((willDelete) => {
      if (willDelete) {
        this.setState({ loadingBtn: true });
        formData.append("data[id_pengelola]", id);
        formData.append("data[soft_delete]", 1);
        axios
          .put(AppConfig.DeletePengelolaPT, formData)
          .then((res) => {
            swal({
              title: "Sukses!",
              text: "Data berhasil dihapus!",
              icon: "success",
              button: "OK!",
            });
            this.componentDidMount();
            this.setState({
              loadingBtn: false,
            });
          })
          .catch((err) => {
            swal({
              title: "Gagal!",
              text: "Gagal menghapus data!",
              icon: "error",
              button: "OK!",
            });
            this.setState({
              loadingBtn: false,
            });
          });
      }
    });
  }

  // Searh
  onClickSearch = (e) => {
    this.setState(
      {
        loadingSearch: true,
        loadingList: true,
        currentPage: 1,
      },
      () => {
        this.componentDidMount();
      }
    );
  };
  onClickResetKeyword = (e) => {
    this.setState(
      {
        keyword: "",
        loadingList: true,
        currentPage: 1,
      },
      () => {
        this.componentDidMount();
      }
    );
  };
  onInputKeyword = (e) => {
    this.setState({
      keyword: e.target.value,
    });
  };

  // Pagination
  getPaginationGroup = () => {
    let start =
      Math.floor((this.state.currentPage - 1) / this.state.pageLimit) *
      this.state.pageLimit;
    return new Array(this.state.pageLimit)
      .fill()
      .map((_, idx) => start + idx + 1);
  };

  pagination(e, item) {
    let dataStart = item * this.state.limit - this.state.limit;
    this.setState(
      {
        start: dataStart,
        currentPage: item,
      },
      () => {
        this.componentDidMount();
      }
    );
  }
  firstPagination = () => {
    let first = this.state.currentPage / this.state.currentPage;
    let dataStart = first * this.state.limit - this.state.limit;
    this.setState(
      {
        start: dataStart,
        currentPage: first,
      },
      () => {
        this.componentDidMount();
      }
    );
  };
  prevPagination = () => {
    let prev = this.state.currentPage - 1;
    let dataStart = prev * this.state.limit - this.state.limit;
    this.setState(
      {
        start: dataStart,
        currentPage: prev,
      },
      () => {
        this.componentDidMount();
      }
    );
  };
  nextPagination = () => {
    let next = this.state.currentPage + 1;
    let dataStart = next * this.state.limit - this.state.limit;
    this.setState(
      {
        start: dataStart,
        currentPage: next,
      },
      () => {
        this.componentDidMount();
      }
    );
  };
  lastPagination = () => {
    let last = this.state.totalPaginationNumber;
    let dataStart = last * this.state.limit - this.state.limit;
    this.setState(
      {
        start: dataStart,
        currentPage: last,
      },
      () => {
        this.componentDidMount();
      }
    );
  };

  // Layout ============================================================================
  render() {
    let userdata = JSON.parse(localStorage.getItem("sessiondata"));
    console.log("role =", userdata.i_idrole);
    let i = 0;
    let list_result = [];
    if (this.state.getRole !== undefined) {
      for (var key in this.state.getRole) {
        list_result[i] = {
          result: this.state.getRole[key],
        };
        i++;
      }
    }
    let no = this.state.showFrom - 1;

    let resetKeyword = <></>;
    if (this.state.keyword !== "") {
      resetKeyword = (
        <i
          onClick={(e) => this.onClickResetKeyword(e)}
          className="flaticon-close text-dark"
          style={{
            position: "absolute",
            zIndex: 2,
            right: "25px",
            bottom: "10px",
            cursor: "pointer",
          }}
        ></i>
      );
    }

    let loadingSearch = <></>;
    if (this.state.loadingSearch === true) {
      loadingSearch = (
        <i
          className="spinner spinner-white"
          style={{ marginRight: "20px" }}
        ></i>
      );
    }

    let pagination = <></>;
    if (this.state.loadingList === false) {
      pagination = (
        <>
          <div className="col-md-8" style={{ textAlign: "center" }}>
            <MDBRow>
              <MDBCol>
                <MDBPagination circle>
                  <MDBPageItem
                    className={`prev ${
                      this.state.currentPage === 1 ? "disabled" : ""
                    }`}
                  >
                    <MDBPageNav
                      className="page-link"
                      onClick={(e) => this.firstPagination(e)}
                    >
                      <span>First</span>
                    </MDBPageNav>
                  </MDBPageItem>
                  <MDBPageItem
                    className={`prev ${
                      this.state.currentPage === 1 ? "disabled" : ""
                    }`}
                  >
                    <MDBPageNav
                      className="page-link"
                      aria-label="Previous"
                      onClick={(e) => this.prevPagination(e)}
                    >
                      <span aria-hidden="true">&laquo;</span>
                      <span className="sr-only">Previous</span>
                    </MDBPageNav>
                  </MDBPageItem>
                  {this.getPaginationGroup()
                    .filter(
                      (index) => index <= this.state.totalPaginationNumber
                    )
                    .map((item, index) => (
                      <MDBPageItem
                        active={this.state.currentPage === item ? true : false}
                        key={index}
                      >
                        <MDBPageNav
                          className="page-link"
                          onClick={(e) => this.pagination(e, item)}
                        >
                          {item}
                        </MDBPageNav>
                      </MDBPageItem>
                    ))}
                  <MDBPageItem
                    disabled={
                      this.state.currentPage ===
                      this.state.totalPaginationNumber
                        ? true
                        : false
                    }
                  >
                    <MDBPageNav
                      className="page-link"
                      onClick={(e) => this.nextPagination(e)}
                    >
                      &raquo;
                    </MDBPageNav>
                  </MDBPageItem>
                  <MDBPageItem
                    disabled={
                      this.state.currentPage ===
                      this.state.totalPaginationNumber
                        ? true
                        : false
                    }
                  >
                    <MDBPageNav
                      className="page-link"
                      onClick={(e) => this.lastPagination(e)}
                    >
                      Last
                    </MDBPageNav>
                  </MDBPageItem>
                </MDBPagination>
              </MDBCol>
            </MDBRow>
          </div>
        </>
      );
    }

    return (
      <>
        <NoticePengelolaanPT style={{ marginBottom: "0px", boxShadow: "none" }}>
          <strong style={{ fontSize: "18px" }}>
            Pengelola Perguruan Tinggi
          </strong>
          <p>Pengaturan Pengelola Perguruan Tinggi</p>
        </NoticePengelolaanPT>
        <br />
        <Card style={{ padding: "2%" }}>
          <div className="row" style={{ marginBottom: "20px" }}>
            <div className="col-md-12">
              <div className="row">
                <div className="col-md-6"></div>
                <div className="col-md-2 text-left"></div>
                
                <div className="col-md-4 text-right">
                    {userdata.i_idrole === 3 && (
                      list_result.length < 3 ? (
                        <Button
                          onClick={this.modalAdd}
                          variant="primary"
                          style={{
                            padding: "12px",
                            width: "50%",
                          }}
                        >
                          <i
                            className="flaticon-add"
                            style={{ color: "#ffffff", fontSize: "14px" }}
                          ></i>
                          &nbsp; Tambah Pengelola
                        </Button>
                      ) : (
                        <div style={{ color: 'red', fontSize: '14px' }}>
                          Maksimal hanya tiga data Pengelola PT yang bisa ditambahkan
                        </div>
                      )
                    )}
                  </div>

              </div>
            </div>
          </div>
          {/*========================================== Begin Table ========================================== */}
          <Table responsive hover style={{ overflow: "auto" }}>
            <thead
              className="text-white"
              style={{ backgroundColor: "#3047ad" }}
            >
              <tr>
                
                
                <th
                  style={{
                    width: "5%",
                    fontSize: "12px",
                    textTransform: "uppercase",
                    verticalAlign: "middle",
                    textAlign: "center",
                  }}
                >
                  No
                </th>
                {
                  userdata.i_idrole !== 10 ? 
                  ''
                  :
                  <th
                    style={{
                      fontSize: "12px",
                      textTransform: "uppercase",
                      verticalAlign: "middle",
                      }}
                    >
                    Nama PT
                  </th>
                }
                <th
                  style={{
                    fontSize: "12px",
                    textTransform: "uppercase",
                    verticalAlign: "middle",
                  }}
                >
                  Nama Pengelola
                </th>
                <th
                  style={{
                    fontSize: "12px",
                    textTransform: "uppercase",
                    verticalAlign: "middle",
                  }}
                >
                  Jabatan
                </th>
                <th
                  style={{
                    fontSize: "12px",
                    textTransform: "uppercase",
                    verticalAlign: "middle",
                  }}
                >
                  No Handhphone
                </th>
                <th
                  style={{
                    fontSize: "12px",
                    textTransform: "uppercase",
                    verticalAlign: "middle",
                  }}
                >
                  Email
                </th>
                {
                  userdata.i_idrole !== 3 ? 
                  ''
                  :
                  <th
                    className="text-center"
                    style={{
                      fontSize: "12px",
                      textTransform: "uppercase",
                      verticalAlign: "middle",
                      textAlign: "center",
                    }}
                  >
                    Aksi
                  </th>

                }
                
              </tr>
            </thead>
            <tbody>
              {this.state.loadingList === true ? (
                <tr>
                  <td colSpan="6">
                    <LinearProgress color="secondary" variant="query" />
                  </td>
                </tr>
              ) : list_result.length > 0 ? (
                list_result.map((list) => (
                  <tr key={list.result.id_pengelola}>
                    <td
                      style={{ verticalAlign: "middle", textAlign: "center" }}
                    >
                      {(no = no + 1)}
                    </td>
                    {
                      userdata.i_idrole !== 10 ? 
                      ''
                      :
                      <td
                        style={{ verticalAlign: "middle", textAlign: "" }}
                      >
                        {list.result.nm_lemb}
                      </td>
                    }
                    <td style={{ verticalAlign: "middle" }}>
                      {list.result.nm_pengelola}
                    </td>
                    <td style={{ verticalAlign: "middle" }}>
                      {list.result.jabatan}
                    </td>
                    <td style={{ verticalAlign: "middle" }}>
                      {list.result.hp}
                    </td>
                    <td style={{ verticalAlign: "middle" }}>
                      {list.result.email}
                    </td>
                    {
                      userdata.i_idrole !== 3 ?
                      ''
                      :
                      <td
                      style={{ verticalAlign: "middle", textAlign: "center" }}
                    >
                      <Button
                        onClick={() => this.modalEdit(list.result)}
                        className="btn btn-icon btn-success btn-sm"
                        style={{
                          minWidth: "50px",
                          marginRight: "10px",
                          borderRadius: "12px",
                        }}
                      >
                        <i
                          className="flaticon-edit"
                          style={{ color: "#FFFFFF", fontSize: "14px" }}
                        ></i>
                      </Button>
                      <Button
                        onClick={() =>
                          this.showDialogDelete(list.result.id_pengelola)
                        }
                        className="btn btn-icon btn-danger btn-sm"
                        style={{
                          minWidth: "50px",
                          marginLeft: "10px",
                          borderRadius: "12px",
                        }}
                      >
                        <i
                          className="flaticon-delete"
                          style={{ color: "#FFFFFF", fontSize: "14px" }}
                        ></i>
                      </Button>
                    </td>
                    }
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="3" style={{ textAlign: "center" }}>
                    <em>Data does not exist</em>
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
          <div className="row" style={{ marginTop: "10px" }}>
            <div className="col-md-4 text-left">
              {" "}
              <label style={{ fontSize: 11, fontStyle: "italic" }}>
                Page <strong>{this.state.currentPage}</strong> of{" "}
                <strong>{this.state.totalPaginationNumber}</strong>
              </label>
            </div>
            <div className="col-md-4 text-center">{pagination}</div>
            <div className="col-md-4 text-right">
              <label style={{ fontSize: 11, fontStyle: "italic" }}>
                Showing <strong>{this.state.showFrom}</strong> to{" "}
                <strong>
                  {this.state.showFrom + this.state.getRole.length - 1}
                </strong>{" "}
                of <strong>{this.state.totalData}</strong> Data
              </label>
            </div>
          </div>
          {/* ========================================== End Table ========================================== */}
        </Card>

        {/*========================================== Begin Modal Add ========================================== */}
        <Modal
        size="lg"
        show={this.state.showAddPengelolaPT}
        onHide={this.handleClose}
      >
        <Modal.Header closeButton>
          <Modal.Title>Form Penambahan Pengelola Perguruan Tinggi</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group controlId="formNamaPengelola">
              <Form.Label>
                Nama Pengelola <span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                size="lg"
                type="text"
                placeholder="Masukkan nama pengelola..."
                value={this.state.nm_pengelola}
                onChange={(e) => this.onInputForm(e, "nm_pengelola")}
                isInvalid={!this.state.nm_pengelola.trim()}
              />
              <Form.Control.Feedback type="invalid">
                Nama Pengelola diperlukan.
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group controlId="formNoHp">
              <Form.Label>
                Nomer Handphone <span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                size="lg"
                type="number"
                placeholder="Masukkan nomor handphone..."
                value={this.state.hp}
                onChange={(e) => this.onInputForm(e, "hp")}
                isInvalid={!this.state.hp.trim()}
              />
              <Form.Control.Feedback type="invalid">
                Nomer Handphone diperlukan.
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group controlId="formEmail">
              <Form.Label>
                Email <span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                size="lg"
                type="email"
                placeholder="Masukkan email..."
                value={this.state.email}
                onChange={(e) => this.onInputForm(e, "email")}
                isInvalid={!this.state.email.trim() || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.state.email)}
              />
              <Form.Control.Feedback type="invalid">
                Email diperlukan dan harus valid.
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group controlId="formJabatan">
              <Form.Label>
                Jabatan <span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                size="lg"
                type="text"
                placeholder="Masukkan jabatan..."
                value={this.state.jabatan}
                onChange={(e) => this.onInputForm(e, "jabatan")}
                isInvalid={!this.state.jabatan.trim()}
              />
              <Form.Control.Feedback type="invalid">
                Jabatan diperlukan.
              </Form.Control.Feedback>
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <div style={{ textAlign: "right" }}>
            <Button
              onClick={this.handleSave}
              disabled={this.state.loadingBtn}
              style={{
                marginRight: "1vw",
                backgroundColor: "#2061e3",
                color: "white",
              }}
              variant="primary"
            >
              SIMPAN
              {this.state.loadingBtn && (
                <i className="ml-3 spinner spinner-white"></i>
              )}
              &nbsp;&nbsp;
            </Button>
          </div>
          <Button
            variant="secondary"
            disabled={this.state.loadingBtn}
            onClick={this.handleClose}
          >
            Tutup
          </Button>
        </Modal.Footer>
      </Modal>

        {/*========================================== End Modal Add ========================================== */}

        {/*========================================== Begin Modal Edit ========================================== */}
        <Modal
          size="lg"
          show={this.state.showDetailsRole}
          onHide={this.handleClose}
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>Form Edit Role</Modal.Title>
          </Modal.Header>
          <Modal.Body>
          <Form>
            <Form.Group controlId="formNamaPengelola">
              <Form.Label>
                Nama Pengelola <span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                size="lg"
                type="text"
                placeholder="Masukkan nama pengelola..."
                value={this.state.nm_pengelola}
                onChange={(e) => this.onInputForm(e, "nm_pengelola")}
                isInvalid={!this.state.nm_pengelola.trim()}
              />
              <Form.Control.Feedback type="invalid">
                Nama Pengelola diperlukan.
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group controlId="formNoHp">
              <Form.Label>
                Nomer Handphone <span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                size="lg"
                type="number"
                placeholder="Masukkan nomor handphone..."
                value={this.state.hp}
                onChange={(e) => this.onInputForm(e, "hp")}
                isInvalid={!this.state.hp.trim()}
              />
              <Form.Control.Feedback type="invalid">
                Nomer Handphone diperlukan.
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group controlId="formEmail">
              <Form.Label>
                Email <span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                size="lg"
                type="email"
                placeholder="Masukkan email..."
                value={this.state.email}
                onChange={(e) => this.onInputForm(e, "email")}
                isInvalid={!this.state.email.trim() || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.state.email)}
              />
              <Form.Control.Feedback type="invalid">
                Email diperlukan dan harus valid.
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group controlId="formJabatan">
              <Form.Label>
                Jabatan <span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                size="lg"
                type="text"
                placeholder="Masukkan jabatan..."
                value={this.state.jabatan}
                onChange={(e) => this.onInputForm(e, "jabatan")}
                isInvalid={!this.state.jabatan.trim()}
              />
              <Form.Control.Feedback type="invalid">
                Jabatan diperlukan.
              </Form.Control.Feedback>
            </Form.Group>
          </Form>
        </Modal.Body>
          <Modal.Footer>
            <div style={{ textAlign: "right" }}>
              <Button
                onClick={this.handleEdit}
                disabled={this.state.loadingBtn}
                style={{
                  marginRight: "1vw",
                  backgroundColor: "#2061e3",
                  color: "white",
                }}
                variant="primary"
              >
                SIMPAN
                {this.state.loadingBtn && (
                  <i className="ml-3 spinner spinner-white"></i>
                )}
                &nbsp;&nbsp;
              </Button>
            </div>
            <Button
              variant="secondary"
              disabled={this.state.loadingBtn}
              onClick={this.handleClose}
            >
              Close
            </Button>
          </Modal.Footer>
        </Modal>
        {/*========================================== End Modal Edit ========================================== */}
      </>
    );
  }
}
export default ManajemenRole;
